import { render, staticRenderFns } from "./ListRoom2.vue?vue&type=template&id=4fe53834"
import script from "./ListRoom2.vue?vue&type=script&lang=js"
export * from "./ListRoom2.vue?vue&type=script&lang=js"
import style0 from "./ListRoom2.vue?vue&type=style&index=0&id=4fe53834&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports